import React from 'react';
import { AlertTriangle, Eye, ShieldCheck } from 'lucide-react';

export function RecommendedActionCards({ actions = [], onPreview, isLoading }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-3">
        <h3 className="text-sm font-extrabold text-slate-900">Recommended Admin Actions</h3>
        <p className="text-xs text-slate-500">Previsualiza antes de ejecutar. Nada es automático.</p>
      </div>
      {actions.length > 0 ? (
        <div className="space-y-2">
          {actions.map((action, index) => (
            <button
              key={`${action.type || 'action'}-${index}`}
              onClick={() => onPreview?.(action)}
              disabled={isLoading}
              className="w-full rounded-xl border border-slate-200 bg-slate-50 p-3 text-left text-xs hover:border-[#B1336E] hover:bg-white disabled:opacity-50"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-extrabold text-slate-900">{action.label || action.type}</span>
                <span className="rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-slate-500">{action.type}</span>
              </div>
              {action.reason && <p className="mt-1 text-slate-500">{action.reason}</p>}
              <div className="mt-2 flex items-center gap-1 text-[10px] font-extrabold uppercase text-[#B1336E]">
                <Eye className="h-3 w-3" /> Preview required
              </div>
            </button>
          ))}
        </div>
      ) : (
        <div className="rounded-lg border border-dashed border-slate-200 p-3 text-xs text-slate-500">
          No hay acciones recomendadas pendientes.
        </div>
      )}
    </div>
  );
}

export function CustomerNotAnsweringPanel({ isActive, onPreview, isLoading }) {
  if (!isActive) return null;
  const quickActions = [
    {
      type: 'acknowledge_driver_hold',
      label: 'Acknowledge driver',
      reason: 'Confirmar al motorizado que operaciones recibió la incidencia cliente no contesta.',
      payload: { incident_intent: 'customer_not_answering' },
    },
    {
      type: 'notify_store_customer_not_answering',
      label: 'Notify store',
      reason: 'Avisar a tienda para soporte o confirmación alternativa con el cliente.',
      payload: { incident_intent: 'customer_not_answering' },
    },
    {
      type: 'reset_remaining_route_to_pending',
      label: 'Reset remaining route to pending',
      reason: 'Preparar reset de entregas restantes del conductor a pendiente si la operación lo confirma.',
      payload: { incident_intent: 'customer_not_answering', reason: 'customer_not_answering', scope: 'current_and_after' },
      mutates: true,
    },
  ];

  return (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 shadow-sm">
      <div className="mb-3 flex items-start gap-2 text-red-900">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <div>
          <h3 className="text-sm font-extrabold">Cliente no contesta UX</h3>
          <p className="text-xs font-semibold text-red-700">Acciones de un click solo generan preview. La ejecución final requiere confirmación.</p>
        </div>
      </div>
      <div className="grid gap-2">
        {quickActions.map(action => (
          <button
            key={action.type}
            onClick={() => onPreview?.(action)}
            disabled={isLoading}
            className="rounded-lg border border-red-200 bg-white p-3 text-left text-xs hover:border-red-400 disabled:opacity-50"
          >
            <div className="flex items-center justify-between gap-2">
              <span className="font-extrabold text-slate-900">{action.label}</span>
              <ShieldCheck className="h-3.5 w-3.5 text-red-600" />
            </div>
            <p className="mt-1 text-slate-500">{action.reason}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
